import React, { useState } from 'react';
import MenuOperaciones from '../menuOperaciones';
import Operaciones from '../Operaciones';

function VerOperaciones() {
  const [menuOpen, setMenuOpen] = useState(true);
  const sidebarWidth = menuOpen ? 250 : 70;

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        background: '#0c1f1d',
        paddingLeft: sidebarWidth,
        transition: 'padding-left .25s ease'
      }}
    >
      <MenuOperaciones
        defaultOpen={menuOpen}
        onToggle={(next) => setMenuOpen(next)}  // actualiza margen del contenido
      />

      <main
        className="contenido-panel"
        style={{
          flex: 1,
          minWidth: 0,
          transition: 'margin-left .25s ease',
          padding: 10,
          background: 'radial-gradient(900px 600px at -10% -10%, #183c34 0%, transparent 45%), #0c1f1d'
        }}
      >
        <Operaciones/>
      </main>
    </div>
  );
}

export default VerOperaciones;
